import store from 'src/js/store';
import getUserPreferences from '../../user/selectors/user-preferences';

const isDifmOrderSubmitted = () => {
  const state = store.getState();
  const userPreferences = getUserPreferences(state);

  return userPreferences?.difmOrderSubmitted;
};

export default isDifmOrderSubmitted;
